import React from 'react'
import cn from 'classnames'

import styles from './Mac.module.css'

export default ({ type }) => (
  <div className={styles.container}>
    <div className={cn(styles.mac, styles[type])}>
    </div>
    <div className={cn(styles.cog, styles.top)}>
    </div>
    <div className={cn(styles.cog, styles.bottom)}>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Mac.js